import React from 'react';
import { Menu } from 'antd';
import { CheckIcon } from '@icons';

export interface IStatusItem {
  name: string;
  status: 'todo' | 'in_progress' | 'stuck' | 'done' | undefined;
  background: string;
}

export const statusMenuList: Array<IStatusItem> = [
  {
    name: 'To do',
    status: 'todo',
    background: '#65BBFB'
  },
  {
    name: 'In progress',
    status: 'in_progress',
    background: '#F8B54E'
  },
  {
    name: 'Done',
    status: 'done',
    background: '#53CDA1'
  },
  {
    name: 'Blocked',
    status: 'stuck',
    background: '#FB7F63'
  }
];

export function statusMenu(
  selectedStatus: string | null,
  handleChangeTaskStatus: (item: IStatusItem) => void
) {
  return (
    <Menu className="priority-menu">
      {statusMenuList.map((item: IStatusItem, index: number) => (
        <Menu.Item
          className="menu-item"
          onClick={() => handleChangeTaskStatus(item)}
          key={index.toString()}
        >
          <div>
            <div style={{ backgroundColor: item.background }} />
            <span>{item.name}</span>
          </div>
          {selectedStatus === item.status && <CheckIcon />}
        </Menu.Item>
      ))}
    </Menu>
  );
}
